import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsOptions from "components/contributors-options"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import ContributorsTableHead from "components/contributors-table-head"
import { VIEW_TYPES } from "helpers/base"
import { METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import { METRIC_TYPES } from "helpers/assets/constants"
import { getPerformanceFormatter } from "helpers/analyze"
import { numberFormatter } from "helpers/formatters/numbers"
import "./style.scss"

function getPerformanceTooltip(metricType) {
  return metricType === METRIC_TYPES.CURRENCY_PERFORMANCE ? "$ Performance" : "% Performance"
}

function getPerformanceLabel(metricType) {
  return metricType === METRIC_TYPES.CURRENCY_PERFORMANCE ? "$ Perf." : "% Perf."
}

function ContributorsDetails({
  viewType,
  selectedValue,
  selected,
  hide,
  data,
  openSecurityProfile,
  openFactorProfile,
  openCompositeSecurity,
  sort,
  order,
  selectedGroup,
  selectedGroupSiblings,
  showGroup,
  hideGroup,
  setContributorsGrouping,
  contributorsGrouping,
  groupedData,
  availableRollups,
  contributorsSummaryText,
  csvData,
  selectedOption,
  selectedGroupValue,
  showNotHeld,
  toggleShowNotHeld,
  groupBy,
  details,
  show,
  groupOrder,
  groupsDropdownColumns,
  metricType,
}) {
  const showNotHeldToggle = viewType === VIEW_TYPES.ACTIVE ? toggleShowNotHeld : null
  const onBackClick = selectedGroup ? hideGroup : hide
  const selectedOptionColor = get(selectedOption, "color")
  const formatter = getPerformanceFormatter(metricType)

  return <div className="contributors-details-wrapper">
    <ContributorsOptions
      contributorsSummaryText={contributorsSummaryText}
      availableRollups={availableRollups}
      setGrouping={setContributorsGrouping}
      currentGrouping={contributorsGrouping}
      selectedGroup={selectedGroup}
      csvData={csvData}
      showNotHeld={showNotHeld}
      toggleShowNotHeld={showNotHeldToggle}
      groupBy={groupBy}
    />
    <Table className="contributors-details-table">
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell />
          <TableCell align="right" title={getPerformanceTooltip(metricType)}>{getPerformanceLabel(metricType)}</TableCell>
        </TableRow>
        <TableRow className="sorting-row">
          <ContributorsSorting label="Name" id="name" order={order} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "Avg % Equity" : "Avg Active % Eq"} id="equity" order={order} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"} id="viewType" order={order} sort={sort} />
        </TableRow>
        <TableRow>
          <ContributorsTableHead
            label={selectedGroup ? selectedGroup.name : selected.label}
            color={selectedOptionColor}
            onBackClick={onBackClick}
            dropdownColumns={groupsDropdownColumns}
            dropdownItems={selectedGroup ? selectedGroupSiblings : sortData(details, groupOrder)}
            onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : show(item)}
            selectedItemId={selectedGroup ? selectedGroup.id : selected.id}
            formatter={formatter}
          />
          <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
          <TableCell align="right" style={{ color: selectedOptionColor }}>{formatter(selectedGroupValue || selectedValue)}</TableCell>
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        selected={selected}
        openSecurityProfile={openSecurityProfile}
        openFactorProfile={openFactorProfile}
        openCompositeSecurity={openCompositeSecurity}
        data={data}
        contributorsGrouping={contributorsGrouping}
        selectedGroup={selectedGroup}
        showGroup={showGroup}
        groupedData={groupedData}
        formatter={formatter}
      />
    </Table>
  </div>
}

ContributorsDetails.propTypes = {
  selected: PropTypes.object.isRequired,
  selectedValue: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  order: PropTypes.object.isRequired,
  hide: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  setContributorsGrouping: PropTypes.func.isRequired,
  contributorsGrouping: PropTypes.object,
  groupedData: PropTypes.array.isRequired,
  availableRollups: PropTypes.array.isRequired,
  contributorsSummaryText: PropTypes.string.isRequired,
  csvData: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  selectedGroupValue: PropTypes.number,
  showNotHeld: PropTypes.bool.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
  groupBy: PropTypes.string,
  details: PropTypes.array.isRequired,
  show: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  groupsDropdownColumns: PropTypes.array.isRequired,
  tagCategories: PropTypes.array,
  metricType: METRIC_TYPES_SHAPE,
}

export default ContributorsDetails
